export const text = {
  products: "All Products",
};
